import { getCurrentDate } from "../../../../Common/helper/helpar";

export const getInspectionReportDefaultFilters = () => ({
  wardId: "",
  fromDate: getCurrentDate(),
  toDate: getCurrentDate(),
});

export const fetchInspectionReportExportData = async (
  fetchReportList,
  storeState,
  errorMessage
) => {
  const { filters, totalRecords, pageSize, rows } = storeState;
  const exportPageSize = Math.max(totalRecords, pageSize, 1);

  try {
    const response = await fetchReportList({
      ...filters,
      pageNumber: 1,
      pageSize: exportPageSize,
    });

    return response.data ?? [];
  } catch (error) {
    console.error(errorMessage, error);
    return rows;
  }
};
